// extracted by mini-css-extract-plugin
module.exports = {"container":"container__2TqRb","list":"list__2fVAG","collapsed":"collapsed__G0xLl"};